import Lottie from "react-lottie";
import {ChatState} from "../Context/ChatProvider";
import Encode from './Encode';
import Decode from './Decode';
import DroppableInput from './DroppableInput';
import CartoonAnimation from '../utils/animations/CartoonAnimation';
import { allowedSet, Alphabet, MAX_SECRETCODE_LENGTH } from './../utils/constants';

const MessagesInputs = ({istyping, defaultOptions, newMessage, typingHandler,  setCodedMessage, setDecodedMessage, sendMessage, showToast, isVanishing, setAdditionalToken, userToken, secretCode, setSecretCode }) => {

    const { writeRead } = ChatState();
    const setAndCheckSecretCode = (e) => {
        const value = e.target.value;
        if (e.nativeEvent.inputType === 'deleteContentBackward' && writeRead === false) {
            showToast('warning', 'Type the key message from the beginning.');
            return setSecretCode("");
        }
        if (value.match(/[<>&]/)) {
            showToast('warning', 'Please avoid using <, >, & characters (in Secretcode).');
            const sanitizedValue = value.replace(/[<>&]/g, '').slice(0, MAX_SECRETCODE_LENGTH);
            setSecretCode(sanitizedValue);
            return;
        }
        if (value.length > MAX_SECRETCODE_LENGTH && writeRead === true) {
            showToast('warning', 'Please do not use such a long secret word.');
            const cutValue = value.slice(0, MAX_SECRETCODE_LENGTH);
            setSecretCode(cutValue);
            return;
        } 
        const lastChar = value.slice(-1); 
        if (value !== "" && !allowedSet.has(lastChar) && lastChar !== " ") {
            showToast('warning', 'This character is not used for your language mode.');
            return; 
        }
        setSecretCode(value);
        const time = new Date().toString().slice(0, 15).replace(/\s+/g, '');
        const secretCodeCode = value.replace(/ /g, '_');
        const numAlph = {};
        for(let i=0; i<Alphabet.length; i++) {
            numAlph[Alphabet[i]] = i;
        }
        let additionalToken = "";
        const codeForToken = userToken + time;
        for(let i=0; i<secretCodeCode.length; i++) {
            additionalToken += Alphabet[(numAlph[secretCodeCode[i]] + numAlph[codeForToken[i % codeForToken.length]]) % Alphabet.length];
        }
        setAdditionalToken(additionalToken);
    }
    
    return (
        <div className='form-control'   id="first-name">
            {istyping ? (
                <div>
                    <Lottie
                        options={defaultOptions}
                        width={70}
                        style={{ marginBottom: 15, marginLeft: 0 }}
                    />
                </div>
            ) : (
                <></>
            )}
            {writeRead
                ? <input
                    className='updateInput'
                    placeholder="Unencrypted message"
                    value={newMessage}
                    onChange={typingHandler}
                /> 
                : <DroppableInput newMessage={newMessage} secretCode={secretCode}  typingHandler={typingHandler} />
            }
            
            <div className='secret_block'>
                <input
                    type='text'
                    className='updateInput'
                    placeholder='Secret key'
                    value={secretCode}
                    onChange={(e) => setAndCheckSecretCode(e)}
                />
                <div  className='logo-container '>
                    <CartoonAnimation sendMessage={sendMessage} secretCode={secretCode} />
                </div>
            </div>
            {writeRead && <Encode text={newMessage} secretCode={secretCode} setSecretCode={setSecretCode} setCodedMessage={(e)=>setCodedMessage(e)} showToast={showToast} />}
            {!writeRead && <Decode isVanishing={isVanishing} text={newMessage} secretCode={secretCode} setDecodedMessage={(e)=>setDecodedMessage(e)} />}
        </div>
    )
}

export default MessagesInputs
